import { ReactComponent as Calendar } from 'assets/icons/icon-calendar.svg';

export default Calendar;
